import { MyLink } from '@app/shared';
import { getPriceFormat } from '@app/shared/helpers';
import { SubscriptionBasketTypeProps } from './TypeProps';
import { useGetPriceQuery } from '../../module/services/getSubscriptionData';
import { domainSubscription, listRegionShowSubscription } from '../../module/const';
import { useAppSelector } from '@redux/hooks';
import { memo, useEffect } from 'react';
import { useLocation } from '@hooks/useLocation';
import { Part, PartProduct } from '@entities/Product';
import classNames from 'classnames';
import config from '@app/config';
import Icon from './icons/subscription.svg';

import styles from './SubscriptionBasket.module.scss';

export const SubscriptionCartProduct = memo(function SubscriptionBasket({
  className,
  rn,
  part,
  allQuantity,
  handlerBackData,
}: SubscriptionBasketTypeProps) {
  const { SUBDOMAIN: regionSlug, REGION: regionId } = useAppSelector(state => state.header.data.region);
  const { data } = useGetPriceQuery(
    { rn, regionSlug },
    {
      skip:
        part !== Part.Tyres ||
        allQuantity < 4 ||
        !listRegionShowSubscription.includes(parseInt(regionId)) ||
        config.safeModeSubscription === 'true',
    },
  );
  const location = useLocation();
  const utmHref = `&utm_source=kolesoCard&utm_medium=banner&utm_campaign=kolesoPromo&returnUrl=${location?.href}`;
  useEffect(() => {
    handlerBackData && handlerBackData(data);
  }, [data]);

  if (
    config.safeModeSubscription === 'true' &&
    [Part.Tyres, PartProduct.Tyres].includes(part) &&
    listRegionShowSubscription.includes(parseInt(regionId))
  ) {
    return (
      <MyLink
        href={`${domainSubscription}/find-tire?rn=${rn}&region=${regionSlug}&year=3` + utmHref}
        className={classNames(styles.Wrapper, className)}
      >
        <div className={styles.Container}>
          <div className={styles.Text}>{'Шины по подписке'}</div>
          <Icon className={styles.Icon} width={41} height={41} />
        </div>
      </MyLink>
    );
  }

  if (data?.price && data?.url) {
    return (
      <MyLink href={data?.url + utmHref} className={classNames(styles.Wrapper, className)}>
        <div className={styles.Container}>
          <div className={styles.Text}>{`Шины по подписке от ${getPriceFormat(data?.price)} ₽`}</div>
          <Icon className={styles.Icon} width={48} height={48} />
        </div>
      </MyLink>
    );
  } else {
    return null;
  }
});
